import { useMemo } from 'react';

import { useSelector } from '#/reduxState/storeCore';

export function useDepositDisabledMessage(): string | false {
  const depositEnabled = useSelector(
    state => state.exchange.info.depositEnabled
  );
  const isRestrictedRegion = !!useSelector(
    state => state.region.restrictedRegion
  );
  const depositDisabledMessage = useMemo((): false | string => {
    if (isRestrictedRegion) {
      return 'Deposit not available in your region.';
    }
    if (!depositEnabled) {
      return 'Deposits are temporarily disabled.';
    }
    return false;
  }, [depositEnabled, isRestrictedRegion]);
  return depositDisabledMessage;
}
